var React = require('react');

function BoxBallot (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144 192l-.5-175.8A16.2 16.2 0 0 1 159.7 0l255.8.6a16 16 0 0 1 16 16L432 192z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 320v160a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V320zm574.7-32a8.34 8.34 0 0 0 .8-1.2L520 148.2a32.07 32.07 0 0 0-29.7-20.1h-26.6l.2 64 16 32H95.5l16-32h.5l-.2-64H85.7A32.07 32.07 0 0 0 56 148.2L.4 286.8c.3.5.5.7.8 1.2z","className":"fa-primary","key":2})]);
}

BoxBallot.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = BoxBallot;

BoxBallot.default = BoxBallot;
